import {
    HttpContextToken,
    HttpErrorResponse,
    HttpEvent,
    HttpHandlerFn,
    HttpInterceptorFn,
    HttpRequest
} from "@angular/common/http";
import { inject, PLATFORM_ID } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import { Observable, from, throwError } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";
import { Router } from "@angular/router";
import {AuthService} from "./auth.service";

// Marca requisições já reenviadas após um refresh, evitando loop de retry
const AUTH_RETRIED = new HttpContextToken<boolean>(() => false);

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const platformId = inject(PLATFORM_ID);

    let newReq = req;

    if (isPlatformBrowser(platformId)) {
        const token = authService.token();

        if (token) {
            newReq = req.clone({
                setHeaders: {
                    Authorization: `Bearer ${token}`
                }
            });
        }
    }

    return next(newReq).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error.status === 401 && !req.context.get(AUTH_RETRIED)) {
                // Tenta renovar a sessão e reenviar a requisição uma única vez
                return from(authService.refreshSession()).pipe(
                    switchMap(token => {
                        if (!token) {
                            authService.logout();
                            return throwError(() => error);
                        }
                        const retriedReq = newReq.clone({
                            setHeaders: { Authorization: `Bearer ${token}` },
                            context: newReq.context.set(AUTH_RETRIED, true)
                        });
                        return next(retriedReq);
                    })
                );
            }
            if (error.status === 401) {
                authService.logout();
            }
            return throwError(() => error);
        })
    );
};
